import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-content p-m-2" }
const _hoisted_2 = { class: "kn-truncated" }
const _hoisted_3 = { class: "kn-truncated" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("b", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.details?.leftOperandAlias), 1)
    ], 512), [
      [
        _directive_tooltip,
        _ctx.details?.leftOperandAlias,
        void 0,
        { bottom: true }
      ]
    ]),
    _withDirectives(_createVNode("p", _hoisted_3, [
      _createVNode("b", null, _toDisplayString(_ctx.details?.operator.toLowerCase() + ' '), 1),
      _createVNode("small", null, _toDisplayString(_ctx.details?.rightOperandValue.toLowerCase()), 1)
    ], 512), [
      [
        _directive_tooltip,
        _ctx.details?.rightOperandValue,
        void 0,
        { bottom: true }
      ]
    ])
  ]))
}